import React, { useState, useMemo } from 'react';
import { List, useTable } from '@refinedev/antd';
import { Table, Tag, Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { PermissionDto } from '@wellverse/shared-ts';

export const PermissionList: React.FC = () => {
  const { tableProps } = useTable<PermissionDto>({
    resource: 'permissions',
    pagination: { current: 1, pageSize: 20 },
  });

  const [searchText, setSearchText] = useState('');

  const filteredData = useMemo(() => {
    if (!searchText) return tableProps.dataSource;
    const lower = searchText.toLowerCase();
    return tableProps.dataSource?.filter((item: any) =>
      item.resource?.toLowerCase().includes(lower) ||
      item.action?.toLowerCase().includes(lower) ||
      item.description?.toLowerCase().includes(lower)
    );
  }, [tableProps.dataSource, searchText]);

  return (
    <List resource="permissions" canCreate={false}>
      <div style={{ marginBottom: 16 }}>
        <Input
          prefix={<SearchOutlined />}
          placeholder="Search by resource, action..."
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          style={{ width: 320 }}
          allowClear
        />
      </div>
      <Table {...tableProps} dataSource={filteredData} rowKey="id">
        <Table.Column dataIndex="resource" title="Resource" />
        <Table.Column dataIndex="action" title="Action" />
        <Table.Column
          dataIndex="resource"
          title="Permission"
          render={(_, record: PermissionDto) => (
            <Tag
              style={{
                borderColor: '#3ecf8e',
                color: '#3ecf8e',
                background: '#3ecf8e15',
                borderRadius: 9999,
                padding: '2px 12px',
                fontSize: 12,
              }}
            >
              {record.resource}:{record.action}
            </Tag>
          )}
        />
        <Table.Column dataIndex="description" title="Description" render={(v) => v || '—'} />
      </Table>
    </List>
  );
};
